import { render, staticRenderFns } from "./ThemeBtn.vue?vue&type=template&id=3edd890e&scoped=true"
import script from "./ThemeBtn.vue?vue&type=script&lang=ts"
export * from "./ThemeBtn.vue?vue&type=script&lang=ts"
import style0 from "./ThemeBtn.vue?vue&type=style&index=0&id=3edd890e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edd890e",
  null
  
)

export default component.exports